<template>
  <div class="sc-object-card__chart" v-loading="isLoading">
    <div class="sc-object-card__chart-header">
      <r-icon name="bar" :size="20" />
      <r-title type="subtitle-2">
        {{ $t("chart") }}
      </r-title>
      <el-button class="r-button" @click="openModalChart">
        <r-icon name="arrows-maximize" :size="20" />
        <r-title type="subtitle-1">
          {{ $t("disclose") }}
        </r-title>
      </el-button>
    </div>
    <div class="sc-object-card__chart-content">
      <chart-component
        v-if="chartData"
        :chartData="chartData"
        no-legend
        type="type-2"
      />
    </div>
    <el-dialog
      width="900px"
      :title="$t('modal-title')"
      :visible.sync="isVisible"
      append-to-body
      :close-on-click-modal="false"
    >
      <object-card-chart-modal v-if="isVisible" v-bind="$props" />
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import chartComponent from "@/components/chart-component/chart-component";
import objectCardChartModal from "./object-card-chart-modal";

export default {
  components: {
    chartComponent,
    objectCardChartModal
  },
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: ""
    },
    cardData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      isVisible: false,
      date: {
        from: Date.now() - 60 * 60 * 1000,
        to: Date.now()
      },
      chartData: null
    };
  },
  watch: {
    id() {
      this.getChartData();
    }
  },
  created() {
    this.getChartData();
  },
  methods: {
    openModalChart() {
      this.isVisible = true;
    },
    async getChartData() {
      if (!this.data || !this.data.url || !this.id) return;

      try {
        this.isLoading = true;
        const from = moment.utc(this.date.from).format();
        const to = moment.utc(this.date.to).format();

        const url = `${this.data.url}&from=${from}&to=${to}&id=${this.id}`;
        const { data } = await this.$store.dispatch("REQUEST", {
          url
        });
        if (!data) {
          this.isLoading = false;
          return;
        }
        const xAxis = {
          data: Object.keys(data).map(e => moment(e).format("hh:mm"))
        };
        const fieldData = [
          {
            color: "#348D93",
            dataTitle: this.$t("intensity"),
            data: Object.values(data)
          }
        ];
        if (!this.chartData) {
          this.chartData = {};
        }
        this.chartData.xAxis = xAxis;
        this.chartData.data = fieldData;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.sc-object-card__chart {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius);
  background-color: var(--bg_containers);

  &-header {
    display: flex;
    align-items: center;
    background-color: var(--bg_containers);
    padding: 4px;

    > * {
      &:first-child {
        margin-right: 8px;
      }
    }

    .r-button {
      margin-left: auto;
      padding: 4px 6px !important;

      .r-icon {
        margin-right: 2px;
      }
    }
  }

  &-content {
    min-height: 50px;
    padding: 8px;
    box-sizing: border-box;
    width: 100%;
    height: 160px;
  }
}
</style>

<i18n>
{
  "ru": {
    "chart": "График",
    "disclose": "Раскрыть",
    "intensity": "Интенсивность",
    "modal-title": "График проезда ТС"
  },
  "en": {
    "chart": "Chart",
    "disclose": "Disclose",
    "intensity": "Intensity",
    "modal-title": "Vehicle route schedule"
  }
}
</i18n>
